import { Fragment, ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';

import { useTrackEvent } from './useTrackEvent';
import { emit } from '@zapier/events-toolkit-browser';

type Props = {
  children: ReactNode;
};

export function TrackRouting({ children }: Props) {
  const trackEvent = useTrackEvent();
  const { asPath: path } = useRouter();

  useEffect(() => {
    // Only track on the client side
    // and do not track the pre-hydrated path that doesn't include the
    // real params (i.e. [accountId])
    if (
      typeof window !== 'undefined' &&
      !(path.includes('[') && path.includes(']'))
    ) {
      trackEvent('navigate', { path });

      // emit an Avro PageViewEvent in parallel with the pre-Avro nagivate event.
      // this will allow us to begin shifting services over to exclusive use of
      // the PageViewEvent by the end of 2021 (when the necessary ETL adjustments
      // have been incorporated for attribution, etc.)

      // We only need to specify the system name that should be used for the PageViewEvent
      // The other PageViewEvent fields are set by automatically by events-toolkit-browser and the v4 Events API
      // https://engineering.zapier.com/guides/event-streaming/tracking-events/
      emit(
        {
          system_name: 'identity',
        },
        'web_analytics.tracking.page_view.PageViewEvent'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  return <Fragment>{children}</Fragment>;
}
